"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheftAbilityHandler = exports.TheftActorAbilityFactory = exports.TheftAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class TheftAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Theft;
        this.__typeName = "Theft";
    }
}
exports.TheftAbilityArgs = TheftAbilityArgs;
let TheftActorAbilityFactory = class TheftActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Theft", "OneEnemies", 1);
    }
};
TheftActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Theft")
], TheftActorAbilityFactory);
exports.TheftActorAbilityFactory = TheftActorAbilityFactory;
let TheftAbilityHandler = class TheftAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "MagicCard",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Chaos", 55)
            ],
            sequence,
            onHit(sequence) {
                let targetIds = [selectedEnemy];
                if (container.hasAttribute(ability.invokerId, "Charm_Gambler_0")) {
                    targetIds = Array.from(new Set(container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies).concat(selectedEnemy)));
                }
                targetIds.forEach(targetId => {
                    const toSteal = Array.from(enums_1.PRIMARY_ATTRIBUTES).map(attr => ({
                        attr,
                        amount: container.getPercentOfBaseAttributeScore(selectedEnemy, 10, attr)
                    }));
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.LinkedEffectsEffectArgs(toSteal.map(({ attr, amount }) => new core_1.MaxAttributeDecreaseEffectArgs(attr, amount)), true),
                        onApplied: sequence => {
                            for (const allyId of container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)) {
                                container.applyBuff({
                                    sequence,
                                    creatorId: ability.invokerId,
                                    targetId: allyId,
                                    duration: Duration_1.Duration.Turns(2),
                                    effect: new core_1.LinkedEffectsEffectArgs(toSteal.map(({ attr, amount }) => new core_1.MaxAttributeIncreaseEffectArgs(attr, amount)), false),
                                    onApplied: sequence => sequence.pushSequence("sequential")
                                        .push(new core_2.ProjectileVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy), new LocationSelector_1.ActorVfxLocationSelector(allyId), "BlackSmoke", "line"))
                                });
                            }
                        }
                    });
                });
            }
        });
    }
};
TheftAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Theft)
], TheftAbilityHandler);
exports.TheftAbilityHandler = TheftAbilityHandler;
